export default "__VITE_ASSET__BSokvIsL__"